<div class="grid">
  <div class="col-fixed p-0" style="width: 65px;">
    <bv-tool-menu></bv-tool-menu>
  </div>
  <div class="col">
    <div class="col-12">
      <bv-tool-topbar [userProfile]="userProfile"></bv-tool-topbar>
    </div>
    <div class="col-12 navbar-separation">
      <router-outlet></router-outlet>
    </div>
    <div class="col-12">
      <bv-tool-footer></bv-tool-footer>
    </div>
  </div>
</div>
